import axios from '@/components/api/axios';



async function getWelcomeCallQuestion() {
  const res = await axios.axiosGet('/api/welcomeCall/getWelcomeCallQuestion', null);
  return res;
}

async function registerWelcomeCallAnswer(data) {
  const res = await axios.axiosPost('/api/welcomeCall/registerWelcomeCallAnswer', data);
  return res;
}

export default {
  getWelcomeCallQuestion,
  registerWelcomeCallAnswer
}



// WEBPACK FOOTER //
// ./src/components/api/welcomeCall/index.js